import { addPadding, divideIntoWeeks, EMPTY_DAY, generateDaysForMonth } from './monthCalendarUtils';
import { Weekdays } from './Weekdays';
const {
  MONDAY
} = Weekdays;
const defaultOptions = {
  weekStartsOn: MONDAY,
  showFullDates: false
};
function monthCalendar(year, month, options) {
  const mergedOptions = {
    ...defaultOptions,
    ...options
  };
  const days = generateDaysForMonth(year, month);
  const weeks = divideIntoWeeks(days, mergedOptions);
  const weeksWithPadding = addPadding(weeks);
  return weeksWithPadding;
}
export { EMPTY_DAY, monthCalendar };
//# sourceMappingURL=monthCalendar.js.map